import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { taskManagerContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const RedeemTask1 = () => {

  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.tastManager;
  const contract = taskManagerContract(tokenAddress, web3);
  // console.log(tokenAddress, "tokenAddress");

  //This hook for dispute and 2 is parameter
  const redeemTask1 = useCallback(
    async (creater) => {
      console.log(creater, 'payload 2222222221');
      console.log(creater?.signedKeyDetails?.taskId, 2, creater?.signedKeyDetails?.deadline, creater?.signedKeyDetails?.signerSignature, creater?.signedKeyDetails?.signerSignature, 'redeemTask payload 1');
      try {
        const gas = await contract.methods.processTaskAction(creater?.signedKeyDetails?.taskId, 2, creater?.signedKeyDetails?.deadline, creater?.signedKeyDetails?.signerSignature, creater?.signedKeyDetails?.signerSignature).estimateGas({
          from: account
        });
        const details = await contract.methods.processTaskAction(creater?.signedKeyDetails?.taskId, 2, creater?.signedKeyDetails?.deadline, creater?.signedKeyDetails?.signerSignature, creater?.signedKeyDetails?.signerSignature).send({
          from: account,
          gas,
        });
        return details;
      } catch (error) {
        console.log('errorr redeemTask', error);

        throw error;
      }
    },
    [contract, account, web3]
  );
  return { redeemTask1: redeemTask1 };
};
export default RedeemTask1;